import React from 'react';
import { Container, Row } from 'reactstrap';

const HeaderLogo = () => (
  <img
    src='/images/ampol-horizontal.png'
    className='site-header-logo'
    alt='site header logo'
  />
);

const SiteHeader = () => {
  return (
    <div>
      <Container fluid className='App-header'>
        <Row>
          <HeaderLogo />
        </Row>
        <Row>
          <h4 className='navHeadings'>Price & Point Converter</h4>
        </Row>
      </Container>
    </div>
  );
};

export default SiteHeader;
